import beaconService from '../services/BeaconService'
import { getImpressionBeacon, getClickBeacon } from '../redux/hookLogic'

export default function executeBeacon(hookLogic, onBeaconSent, payload, type) {
  const impressionBeacon = getImpressionBeacon(hookLogic, payload.productId)
  const clickBeacon = getClickBeacon(hookLogic, payload.productId)

  if (type === 'impBeacon' && impressionBeacon) {
    beaconService(impressionBeacon)
    onBeaconSent({
      productSku: payload.productId,
      beaconType: 'impression'
    })
  }
  if (type === 'clickBeacon' && clickBeacon) {
    beaconService(clickBeacon)
    onBeaconSent({
      productSku: payload.productId,
      beaconType: 'click'
    })
  }
}
